import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Product } from '../_models/Product';
import { getUrl } from '../_shared/utils';
import { JWTTokenService } from './jwtToken.service';

@Injectable()
export class ProductService {

    public apiUrl = getUrl();

    constructor(private http: HttpClient, private jwtTokenService: JWTTokenService) { }

    public getAll(): Observable<Product[]> {
        return this.http.get<Product[]>(getUrl('product'), this.requestOptionsAuthenticated());
    }

    public get(productId: number): Observable<Product> {
        return this.http.get<Product>(getUrl('product/' + productId), this.requestOptionsAuthenticated());
    }

    private requestOptionsAuthenticated() {
        const requestOptions = {
            headers: new HttpHeaders()
                .set('Content-type', 'application/json')
                .append('Authorization', 'Bearer ' + this.jwtTokenService.getToken('portal')),
        };
        return requestOptions;
    }
}
